export function stringToBoolean(str: string): boolean
{
	return (str.toUpperCase() === "TRUE");
}
